import React from "react";
import { useTranslation } from "react-i18next";
import Heading from "../components/app/Heading/Heading";
import OmronPagingInfo from "../components/app/PagingInfo/PagingInfo";
import OmronResults from "../components/app/Results/Results";
import OmronSearchBox from "../components/app/SearchBox/SearchBox";
import OmronPagination from "../components/app/Pagination/Pagination";
import AppLayoutWrapper from "./AppLayoutWrapper";
import FileFacet from "../components/app/Facets/FileFacet";
import OmronProductFacet from "../components/app/Facets/ProductsFacet";
import queryString from "../../helpers/queryString";

const Title = () => {
  const { t } = useTranslation();
  return <h2 className="c-title--subtitle-border">{t("Search Results")}</h2>;
};

const AppLayout = ({ setSearchTerm, addFilter }) => {
  React.useEffect(() => {
    const search = queryString.parse(window.location.search);
    if (
      search &&
      (Array.isArray(search)
        ? search.length > 0
        : Object.keys(search).length > 0)
    ) {
      const { filters, q } = search;
      if (q) {
        setSearchTerm(q);
      }
      if (filters) {
        filters.forEach(({ field, values, type }) =>
          addFilter(field, values, type),
        );
      }
    }
  }, []);
  return (
    <AppLayoutWrapper>
      <div className="l-main">
        <div>
          <Heading />
          <OmronSearchBox />
          <Title />
          <OmronPagingInfo />
          <OmronResults />
          <OmronPagination />
        </div>
      </div>
      <div className="l-aside">
        <OmronProductFacet />
        <FileFacet />
      </div>
    </AppLayoutWrapper>
  );
};

export default AppLayout;
